import { createReducer } from '../../utils/misc'

import {
  LOADING_MY_SOLCITUD_CREDITO,
  FETCH_MY_SOLCITUD_CREDITO_SUCCESS,
  FETCH_MY_SOLCITUD_CREDITO_ERROR,
  LOADING_SEND_SOLICITUD_CREDITO,
  GET_SEND_SOLICITUD_CREDITO_SUCCESS,
  GET_SEND_SOLICITUD_CREDITO_ERROR,
  FETCH_SOLICITUDES_HISTORY_REQUEST,
  FETCH_SOLICITUDES_HISTORY_SUCCESS,
  FETCH_SOLICITUDES_HISTORY_ERROR,
  FETCH_MCR_DOCUMENTOS_SUCCESS,
  FETCH_MCR_DOCUMENTOS_REQUEST
} from '../constants/solicitudCredito'

const initialState = {
  mySolicitudCredito: {
    tipoAfiliado: '',
    cuotas: 0,
    amount: 0,
    cuotaMensual: 0,
    estadoSolicitud: null,
    totalCredito: 0,
    montoSolicitado: 0,
    vencimiento: '',
    tasaInteres: '',
    cae: '',
    seguros: {
      cesantia: null,
      desgravamen: null
    }
  },
  fetchingMySolicitudCredito: false,
  mySolicitudCreditoError: null,
  statusCCR: '',
  loadingSendSolicitudCredito: false,
  error: null,
  solicitudesHistory: [],
  itemCount: 1,
  pageCount: 1,
  fetchingSolicitudesHistory: false,
  solicitudesHistoryError: null,
  firmarMcr: false,
  urlLoginEcert: null,
  fetchingCrearMcr: false
}

export default createReducer(initialState, {
  [FETCH_MY_SOLCITUD_CREDITO_SUCCESS]: (state, payload) =>
    Object.assign({}, state, {
      mySolicitudCredito: payload ? {
        folio: payload.folio,
        tipoAfiliado: payload.simulacion.oferta.user.tipoAfiliado,
        cuotas: payload.simulacion.cuotas,
        amount: payload.simulacion.amount,
        estadoSolicitud: payload.statusSucursalVirtual,
        montoSolicitado: payload.simulacion.montoSolicitado,
        seguros: {
          cesantia: payload.simulacion.seguroCesantia && true,
          desgravamen: payload.simulacion.seguroDesgravamen && true
        }
      } : null,
      mySolicitudCreditoError: null,
      fetchingMySolicitudCredito: false
    }),
  [LOADING_MY_SOLCITUD_CREDITO]: (state) =>
    Object.assign({}, state, {
      fetchingMySolicitudCredito: true,
      mySolicitudCreditoError: null
    }),
  [FETCH_MY_SOLCITUD_CREDITO_ERROR]: (state, payload) =>
    Object.assign({}, state, {
      fetchingMySolicitudCredito: false,
      mySolicitudCreditoError: payload
    }),
  [LOADING_SEND_SOLICITUD_CREDITO]: (state) =>
    Object.assign({}, state, {
      loadingSendSolicitudCredito: true
    }),
  [GET_SEND_SOLICITUD_CREDITO_SUCCESS]: (state, payload) =>
    Object.assign({}, state, {
      loadingSendSolicitudCredito: false,
      statusCCR: payload.statusCCR,
      firmarMcr: payload.firmarMcr,
      urlLoginEcert: payload.urlLoginEcert
    }),
  [GET_SEND_SOLICITUD_CREDITO_ERROR]: (state) =>
    Object.assign({}, state, {
      loadingSendSolicitudCredito: false,
      statusCCR: ''
    }),
  [FETCH_SOLICITUDES_HISTORY_REQUEST]: (state) =>
    Object.assign({}, state, {
      fetchingSolicitudesHistory: true,
      solicitudesHistoryError: null
    }),
  [FETCH_SOLICITUDES_HISTORY_ERROR]: (state, payload) =>
    Object.assign({}, state, {
      fetchingSolicitudesHistory: true,
      solicitudesHistoryError: payload
    }),
  [FETCH_SOLICITUDES_HISTORY_SUCCESS]: (state, payload) =>
    Object.assign({}, state, {
      fetchingSolicitudesHistory: false,
      solicitudesHistoryError: null,
      solicitudesHistory: payload.solicitudesCreditos,
      itemCount: payload.itemCount,
      pageCount: payload.pageCount
    }),
  [FETCH_MCR_DOCUMENTOS_REQUEST]: (state) =>
    Object.assign({}, state, {
      fetchingCrearMcr: true
    }),
  [FETCH_MCR_DOCUMENTOS_SUCCESS]: (state, payload) =>
    Object.assign({}, state, {
      urlLoginEcert: payload.urlLoginEcert,
      fetchingCrearMcr: false
    })
})
